module.exports = __webpack_public_path__ + "img/PM-logo-temp.7a606402.png";